var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.isImgVerify)?_c('section',{staticClass:"imgVerify"},[_c('DragVerify',{ref:"dragVerify",attrs:{"business":_vm.business},on:{"verifySuccess":_vm.verifySuccess}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }